<script>

    import { modalStore } from '../stores'

    import Button from './button.svelte'

    export let modalId = ''
    export let color = ''
    export let text = ''
    export let size = ''
    export let icon = null

</script>

<Button on:click={() => modalStore.open(modalId)} color={color} {text} {icon} {size}/>